export const fieldData = [
  { id: 1, label: "all fields" },
  { id: 2, label: "educations" },
  { id: 3, label: "organizations" },
  { id: 4, label: "companies" },
];
